import React from "react";
import { StatusIcon } from "components/common";
import { durationToRoundedDays } from "components/indices/data-tiering";
import { archiveRetentionSummary } from "archive/index-set/archiveRetention";
import useIndexSetArchiveSettings from "archive/index-set/useIndexSetArchiveSettings";
import AppConfig from "util/AppConfig";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import { DATA_TIERING_LICENSE_TITLE, DATA_TIERING_LICENSE_TEXT } from "data-tiering/constants";
const TierSummary = ({ config }) => {
  var _a;
  const showArchiveRetention = !AppConfig.isCloud() && ((_a = config.archive_before_deletion) != null ? _a : false);
  const { globalRetentionTime } = useIndexSetArchiveSettings({ enabled: showArchiveRetention });
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Warm Tier:"), /* @__PURE__ */ React.createElement("dd", null, config.warm_tier_enabled ? "Enabled" : "Disabled"), config.warm_tier_enabled && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, "Repository:"), /* @__PURE__ */ React.createElement("dd", null, config.warm_tier_repository_name), /* @__PURE__ */ React.createElement("dt", null, "Min. in Hot Tier:"), /* @__PURE__ */ React.createElement("dd", null, durationToRoundedDays(config.index_hot_lifetime_min), " days")), /* @__PURE__ */ React.createElement("dt", null, "Archive before deletion:"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: config.archive_before_deletion })), showArchiveRetention && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, "Archive retention:"), /* @__PURE__ */ React.createElement("dd", null, archiveRetentionSummary(
    config.archive_retention_override_enabled,
    config.archive_retention_time,
    globalRetentionTime
  )))), config.warm_tier_enabled && /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      text: DATA_TIERING_LICENSE_TEXT,
      title: DATA_TIERING_LICENSE_TITLE,
      licenseSubject: LICENSE_SUBJECTS.enterprise,
      bsStyle: "danger"
    }
  ));
};
export default TierSummary;
